import { compose as lcompose } from 'lodash/fp';
import { right, left, map as emap } from 'fp-ts/lib/Either';
import { pathOr } from 'rambda';
import { log } from '.';

export const handleKey = (a: () => void) =>
  lcompose(
    emap(a),
    key => (key === ' ' || key === 'Enter' ? right(key) : left(key)),
    pathOr('', 'key'),
    log('handleKey')
  );

export const handleTabKey = (a: () => void) =>
  lcompose(
    emap(a),
    key => (key === 'Tab' ? right(key) : left(key)),
    pathOr('', 'key'),
    log('handleKey')
  );
